import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "spr-youtube",
  "use": "spr-youtube-usage",
  "viewBox": "0 0 44 30",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 44 30\" id=\"spr-youtube\">\r\n<style type=\"text/css\">\r\n\t#spr-youtube .st0{fill:#E50000;}\r\n\t#spr-youtube .st1{fill:#FFFFFF;}\r\n</style>\r\n<path class=\"st0\" d=\"M43.5,6.5c0,0-0.4-2.9-1.8-4.3c-1.7-1.7-3.5-1.7-4.4-1.8C31.2,0,22,0,22,0l0,0c0,0-9.2,0-15.3,0.4\r\n\tC5.8,0.5,3.9,0.6,2.1,2.2C0.9,3.6,0.5,6.5,0.5,6.5S0,10,0,13.4v3.2c0,3.5,0.5,6.9,0.5,6.9s0.4,2.9,1.8,4.3c1.7,1.7,3.9,1.7,4.9,1.8\r\n\tC10.6,29.9,22,30,22,30s9.3,0,15.4-0.5c0.9-0.1,2.7-0.1,4.4-1.8c1.3-1.3,1.8-4.3,1.8-4.3s0.4-3.5,0.4-6.9v-3.2\r\n\tC43.9,10,43.5,6.5,43.5,6.5z\" />\r\n<polygon class=\"st1\" points=\"17.5,20.6 17.5,8.5 29.3,14.6 \" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ../img/sprite/youtube.svg
// module id = 209
// module chunks = 0